<template>
  <transition name="fade">
    <div @mouseleave='closeSideBar' :class='{"sideBarStyle": true, "openSideBar": sidebarToggle}'>
      <div :class='{"hide": !sidebarToggle}'>
        <label class='headerForOffer'>{{ this.sidebarHeader}}</label>
        <!-- <span class="closebtn" @click=''>&times;</span> -->
        <!-- <hr> -->
        <div v-if="type === 'offerList'" class="width_full">
          <!-- <select class='ddOffers' id='10' v-model='offerCompSelectedOfferId' @change='change'>
            <option
              v-for='(offer, i) in offerNames'
              :value='offer'
              :selected='gettersSelectedOfferData.id === offer.id'
            >
              {{ offer.value }}
            </option>
          </select> -->
          <searchable-dropdown
            :id='10'
            :list='offerNames'
            v-model='selectedOfferName'
            :defaultText='selectedOfferId'
            :selectedItem='cloneOfferName'
            :screenName='screenName'>
          </searchable-dropdown>
        </div>
        <div v-else-if="type === 'pendingApprovals'" class="margin-reset padding-reset grid-12">
          <div v-if='superUser' class="">
            <label class='ddHeaders'>MERCHANTS:</label>
            <searchable-dropdown
              id='vendorId1'
              :list='merchants'
              v-model='selectedMerchant'
              :defaultText='defaultText'
              :selectedItem='selectedMerchantValue'>
            </searchable-dropdown>
            <label class='ddHeaders'>MANUFACTURERS:</label>
            <searchable-dropdown
              id='superuser1'
              :list='emails'
              v-model='selectedVendor'
              :defaultText='defaultText'
              :selectedItem='selectedItem'>
            </searchable-dropdown>
          </div>
          <label class='ddHeaders'>OFFERS:</label>
          <!-- <select id='offerId' v-model='selectedOfferId'>
            <option v-for='offer in offers' :value='offer.id'> {{ offer.name }} </option>
          </select> -->
          <dropdown
            :id='100'
            :list='offers'
            v-model='selectedOfferId'
            :defaultText='defaultOfferName'
            :selectedItem='(gettersAggInputDataName.offers) ? gettersAggInputDataName.offers.name : ""'>
          </dropdown>
          <label class='ddPeriods'>PERIODS:</label>
          <!-- <select id='periodId' v-model='selectedPeriod'>
            <option v-for='(period, i) in periods' :selected='i === 0' :value='period'> {{ period }} </option>
          </select> -->
          <dropdown
            :id='200'
            :list='periods'
            v-model='selectedPeriod'
            :defaultText='defaultPeriod'
            :selectedItem='(gettersAggInputDataName.period) ? gettersAggInputDataName.period.name : ""' />
          <label class='ddCategory'>CATEGORIES:</label>
          <label class='all-categories' @click='removeFilter'>See All Categories</label>
          <div class="category-body">
            <label class='ddSubHeaders'>DEPARTMENTS:</label>
            <searchable-dropdown
              :id='1'
              :list='departments'
              v-model='selectedDepartment'
              :selectedItem='department ? department.name :null'>
            </searchable-dropdown>
            <!-- <select id='categoryId' v-model='selectedDepartment'>
              <option v-for='category in departmentList' :selected='category'> {{ category }} </option>
            </select> -->

            <label
              class='ddSubHeaders'
              v-if='department'
            > SUB-DEPARTMENTS:</label>
            <searchable-dropdown
              v-if='department'
              :id='2'
              :list='subDepartments'
              v-model='selectedSubDepartment'
              :selectedItem='subDepartment ? subDepartment.name : null'>
            </searchable-dropdown>
            <!-- <select id='categoryId' v-model='selectedSubDepartment' v-if='selectedDepartment &&
             !== null'>
              <option v-for='category in subDepartmentList' :selected='category'> {{ category }} </option>
            </select> -->

            <label
              class='ddSubHeaders'
              v-if='subDepartment && subDepartment !== null'
            > CLASSES:</label>
            <searchable-dropdown
              :reset='reset._class'
              v-if='subDepartment && subDepartment !== null'
              :id='3'
              :list='_class'
              v-model='selectedClass'
              :selectedItem='textClass ? textClass.name: null'>
            </searchable-dropdown>
            <!-- <select id='categoryId' v-model='selectedClass'  v-if='selectedSubDepartment && selectedSubDepartment !== null'>
              <option v-for='category in classList' :selected='category'> {{ category }} </option>
            </select> -->

            <label class='ddSubHeaders' v-if='textClass && textClass !== null'>SUB-CLASSES:</label>
            <searchable-dropdown
              :reset='reset.subClass'
              v-if='textClass && textClass !== null'
              :id='4'
              :list='subClasses'
              v-model='selectedSubClass'
              :selectedItem='subClass ? subClass.name: null'>
            </searchable-dropdown>
            <!-- <select id='categoryId' v-model='selectedSubClass' v-if='selectedClass && selectedClass !== null'>
              <option v-for='category in subClassList' :selected='category'> {{ category }} </option>
            </select> -->

          </div>
          <label class='ddHeaders'>BRANDS:</label>
          <searchable-dropdown
            :id='5'
            :list='brands'
            v-model='selectedBrand'
            :selectedItem='(gettersAggInputDataName.brand) ? gettersAggInputDataName.brand.name : ""'>
          </searchable-dropdown>
          <label class='ddHeaders'>STORES:</label>
          <!-- <select id='corpId' v-model='selectedStoreLevel'>
            <option v-for='(store, i) in storeLevels' :selected='i === 0' :value='store.id'> {{ store.name }} </option>
          </select> -->
          <dropdown
            :id='300'
            :list='storeLevels'
            v-model='selectedStoreLevel'
            :defaultText='defaultStoreLevel'
            :selectedItem='(gettersAggInputDataName.storeLevel) ? gettersAggInputDataName.storeLevel.name : ""'/>
        </div>
        <div class="submitButtonDiv" v-if='submitButtonPresent'>
          <button
            type="button"
            :class="{'submitButton': true, 'width_full': true, 'primary-green-bg': isSubmitButtonEnabled(), 'grey-text': !isSubmitButtonEnabled()}"
            :disabled="!isSubmitButtonEnabled()"
            @click="getPendingApprovals()">
            Submit
          </button>
        </div>

      </div>

    </div>
  </transition>
</template>

<script>
import SearchableDropdown from 'src/components/shared/SearchableDropDown'
import Dropdown from 'src/components/shared/Dropdown'
import { mapActions, mapGetters } from 'vuex'
import * as NameSpace from '../../store/NameSpace'
import { isSuperUser, getVendorId } from 'src/components/shared/helper/superUser'
import { CLEAR_FILTER, EMAIL_SELECTED_BY_SUPERUSER, MERCHANT_SELECTED_BY_SUPERUSER } from 'src/constants/Constants'
import { findIndex, cloneDeep } from 'lodash'

export default {
  data () {
    return {
      filteredOfferNames: [],
      brand: null,
      department: null,
      subDepartment: null,
      textClass: null,
      subClass: null,
      reset: {
        subDepartment: false,
        _class: false,
        subClass: false
      },
      selectedOffer: 'Expand here to select your offer.',
      searchText: 'Search', // If value is falsy, reset searchText & searchItem
      item: {
        value: '',
        text: ''
      },
      filterText: null,
      selectedOfferId: null,
      selectedPeriod: null,
      selectedStoreLevel: null,
      offerCompSelectedOfferId: null,
      selectedOfferName: null,
      defaultOfferName: '',
      clearFlag: false,
      defaultText: '',
      selectedVendor: '',
      selectedMerchant: '',
      selectedItem: '',
      selectedMerchantValue: '',
      superUser: false,
      buttonEnabled: true
    }
  },
  created () {
    let vendor = getVendorId()
    if (vendor) {
      this.selectedVendor = vendor
      this.selectedItem = vendor.name
      // this.buttonEnabled = true
    }
  },
  beforeMount () {
    if (isSuperUser()) {
      this.superUser = true
      // this.buttonEnabled = false
    }
  },
  props: {
    'type': {
      required: true
    },
    'sidebarHeader': {
      required: false
    },
    'offerNames': {
      required: false
    },
    'submitButtonPresent': {
      required: false
    },
    'fetchAggregatedOffer': {
      required: false
    },
    'handleEvent': {
      required: false
    },
    'show': {
      required: false
    },
    'screenName': {
      required: false
    }
  },
  computed: {
    ...mapGetters({
      gettersLandingInfo: NameSpace.GET_LANDING_DATA,
      gettersAggInputDataName: NameSpace.GET_AGG_INPUT_FILTER_NAME,
      gettersSelectedOfferData: NameSpace.GET_SELECTED_OFFER_NAME,
      gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA,
      gettersAllEmails: NameSpace.GETTER_ALL_EMAILS,
      getSelectedMerchant: NameSpace.GET_SELECTED_MERCHANT
    }),
    cloneOfferName () {
      if (this.gettersSelectedOfferData) {
        return cloneDeep(this.gettersSelectedOfferData.name)
      } else {
        return ''
      }
    },
    emails () {
      let emails = this.gettersAllEmails.manufacturers
      return emails.map(data => {
        return {name: data.name, value: data.id}
      })
    },
    data () {
      return this.gettersLandingInfo.data
    },
    merchants () {
      let merchant = this.getSelectedMerchant
      this.selectedMerchant = merchant
      if (merchant && merchant.name) {
        this.selectedMerchantValue = merchant.name
      }
      let merchants = this.data.merchants
      if (merchants.length) {
        return merchants.map(data => {
          return {name: data.email, value: data.id}
        })
      } else {
        return []
      }
    },
    selectedDepartment: {
      get () {
        if (this.clearFlag) {
          return null
        } else {
          this.department = this.department || this.gettersAggInputDataName.department
          return this.department
        }
      },
      set (value) {
        if (value === CLEAR_FILTER) {
          this.clearFlag = true
          this.department = null
          this.removeFromStore()
          this.subDepartment = null
          this.textClass = null
          this.subClass = null
        } else {
          this.clearFlag = false
          this.department = value
          this.subDepartment = null
          if (this.department && this.department.id) {
            this.fetchSubDepartments({ categoryId: this.department.id })
          }
        }
      }
    },
    selectedSubDepartment: {
      get () {
        if (this.clearFlag) {
          return null
        } else {
          this.subDepartment = this.subDepartment || this.gettersAggInputDataName.subDepartment
          return this.subDepartment
        }
      },
      set (value) {
        if (value === CLEAR_FILTER) {
          this.clearFlag = true
          this.subDepartment = null
          this.removeFromStore()
          this.textClass = null
          this.subClass = null
        } else {
          this.clearFlag = false
          this.subDepartment = value
          this.textClass = null
          if (this.subDepartment && this.subDepartment.id) {
            this.fetchClasses({ categoryId: this.subDepartment.id })
          }
        }
      }
    },
    selectedClass: {
      get () {
        if (this.clearFlag) {
          return null
        } else {
          this.textClass = this.textClass || this.gettersAggInputDataName.class
          return this.textClass
        }
      },
      set (value) {
        if (value === CLEAR_FILTER) {
          this.clearFlag = true
          this.textClass = null
          this.removeFromStore()
          this.subClass = null
        } else {
          this.clearFlag = false
          this.textClass = value
          this.subClass = null
          if (this.textClass && this.textClass.id) {
            this.fetchSubClasses({ categoryId: this.textClass.id })
          }
        }
      }
    },
    selectedSubClass: {
      get () {
        if (this.clearFlag) {
          return null
        } else {
          this.subClass = this.subClass || this.gettersAggInputDataName.subClass
          return this.subClass
        }
      },
      set (value) {
        if (value === CLEAR_FILTER) {
          this.clearFlag = true
          this.subClass = null
          this.removeFromStore()
        } else {
          this.clearFlag = false
          this.subClass = value
        }
      }
    },
    selectedBrand: {
      get () {
        if (this.clearFlag) {
          return null
        } else {
          this.brand = this.brand || this.gettersAggInputDataName.brand
          return this.brand
        }
      },
      set (value) {
        if (value === CLEAR_FILTER) {
          this.clearFlag = true
          this.brand = null
        } else {
          this.clearFlag = false
          this.brand = value
        }
      }
    },
    brands () {
      if (this.data) {
        return this.data.brands
      }
    },
    offers () {
      if (this.data) {
        this.defaultOfferName = 'All Offers'
        let found = false
        for (let obj of this.data.offers) {
          if (obj.id === 'MyOffers') {
            found = true
          }
        }
        if (found) {
          this.defaultOfferName = 'My Offers'
        }
        return this.data.offers
      }
    },
    periods () {
      if (this.data && this.data.periods) {
        return this.data.periods.map(e => {
          let obj = {}
          obj.id = e
          obj.name = e
          return obj
        })
      } else {
        return []
      }
    },
    departments () {
      if (this.data) {
        return this.data.departments
      }
    },
    subDepartments () {
      if (this.data) {
        return this.data.subDepartments
      }
    },
    _class () {
      if (this.data) {
        return this.data.classes
      }
    },
    subClasses () {
      if (this.data) {
        return this.data.subClasses
      }
    },
    storeLevels () {
      if (this.data) {
        if (this.data.storeLevel && this.data.storeLevel[0]) {
          this.selectedStoreLevel = this.data.storeLevel[0].id
        }
        return this.data.storeLevel
      }
    },
    sidebarToggle () {
      return this.show
    },
    defaultPeriod () {
      return this.periods.length > 0 ? this.periods[0].name : ''
    },
    defaultStoreLevel () {
      return this.storeLevels.length > 0 ? this.storeLevels[0].name : ''
    }
  },
  methods: {
    ...mapActions({
      actionSelectOfferName: NameSpace.ACTION_SELECT_OFFER_NAME,
      setDepartMent: NameSpace.SET_SELECTED_DEPARTMENT,
      setSubDepartment: NameSpace.SET_SELECTED_SUB_DEPARTMENT,
      setClass: NameSpace.SET_SELECTED_CLASS,
      setSubClass: NameSpace.SET_SELECTED_SUB_CLASS,
      fetchSubDepartments: NameSpace.FETCH_SUB_DEPARTMENTS,
      fetchClasses: NameSpace.FETCH_CLASSES,
      fetchSubClasses: NameSpace.FETCH_SUB_CLASSES,
      setAggInputData: NameSpace.SET_AGG_INPUT_FILTER_DATA,
      setSelectedOffer: NameSpace.ACTION_SELECT_OFFER_NAME,
      storeSelectedVendor: NameSpace.SET_EMAIL_SELECTED_BY_SUPERUSER,
      setSelectedMerchant: NameSpace.SET_SELECTED_MERCHANT
    }),
    isSubmitButtonEnabled () {
      return this.buttonEnabled && (this.periods && this.periods.length && this.storeLevels && this.storeLevels.length)
    },
    checkVendorObject () {
      let vendor = this.selectedVendor
      if (vendor && this.selectedVendor !== CLEAR_FILTER) {
        this.isValidEmailChoosen(vendor)
      } else {
        this.buttonEnabled = true
      }
    },
    checkMerchantObject () {
      if (this.selectedMerchant && this.selectedMerchant !== CLEAR_FILTER) {
        this.isValidMerchantChoosen(this.selectedMerchant)
      } else {
        this.buttonEnabled = true
      }
    },
    isValidEmailChoosen (email) {
      let index = findIndex(this.emails, email)
      if (index >= 0) {
        this.selectedVendor = this.emails[index]
        this.selectedOfferName = this.selectedVendor.name
        this.buttonEnabled = true
      } else {
        this.buttonEnabled = false
      }
    },
    isValidMerchantChoosen (merchant) {
      let index = findIndex(this.merchants, merchant)
      if (index >= 0) {
        this.selectedMerchant = this.merchants[index]
        this.selectedMerchantValue = this.selectedMerchant.name
        this.buttonEnabled = true
      } else {
        this.buttonEnabled = false
      }
    },
    openSideBar () {
      this.sidebarToggle = true
    },
    closeSideBar (e) {
      this.$emit('sidebarInactive', () => true)
    },
    change () {
      if (this.offerCompSelectedOfferId) {
        this.selectedOffer = this.offerCompSelectedOfferId
        this.actionSelectOfferName(this.offerCompSelectedOfferId)
        this.handleEvent(this.selectedOffer)
      }
    },
    onSelect (item) {
      this.item = item
    },
    reset () {
      this.item = {}
    },
    selectOption () {
      this.item = this.options[0]
    },
    filterObjects (text) {
      return this.filteredOfferNames.filter((v) => {
        return Object.keys(v).some((k) => {
          return v[k].toLowerCase().indexOf(text.toLowerCase()) > -1
        })
      })
    },
    getPendingApprovals () {
      if (isSuperUser()) {
        localStorage.setItem(EMAIL_SELECTED_BY_SUPERUSER, JSON.stringify(this.selectedVendor))
        this.storeSelectedVendor(this.selectedVendor)
        localStorage.setItem(MERCHANT_SELECTED_BY_SUPERUSER, JSON.stringify(this.selectedMerchant))
        this.setSelectedMerchant(this.selectedMerchant)
      }
      this.closeSideBar()
      let object = {}
      let stateObject = {}
      if (this.selectedOfferId) {
        stateObject.offers = this.selectedOfferId
        object.offers = this.selectedOfferId.id
      }
      if (this.selectedPeriod) {
        stateObject.period = this.selectedPeriod
        object.period = this.selectedPeriod.id
      }
      if (this.department) {
        stateObject.department = this.department
        object.departmentId = this.department.id
      }
      if (this.subDepartment) {
        stateObject.subDepartment = this.subDepartment
        object.subDepartmentId = this.subDepartment.id
      }
      if (this.textClass) {
        stateObject.class = this.textClass
        object.classId = this.textClass.id
      }
      if (this.subClass) {
        stateObject.subClass = this.subClass
        object.subClassId = this.subClass.id
      }
      if (this.brand) {
        stateObject.brand = this.brand
        object.brandId = this.brand.id
      }
      if (this.selectedStoreLevel) {
        stateObject.storeLevel = this.selectedStoreLevel
        object.storeLevel = this.selectedStoreLevel.id
      }
      console.log('In submit of sidebar:', stateObject)
      this.setAggInputData(stateObject)
      if (isSuperUser()) {
        object.manufacturerId = this.selectedVendor.value
        if (this.selectedMerchant) {
          object.merchantId = this.selectedMerchant.value
        }
      }
      this.fetchAggregatedOffer(object)
    },
    removeFromStore () {
      let object = this.gettersAggInputData
      if (!this.department) {
        delete object.department
        delete object.subDepartment
        delete object.class
        delete object.subClass
      }
      if (!this.subDepartment) {
        delete object.subDepartment
        delete object.class
        delete object.subClass
      }
      if (!this.textClass) {
        delete object.class
        delete object.subClass
      }
      if (!this.subClass) {
        delete object.subClass
      }
      this.setAggInputData(object)
    },
    removeFilter () {
      let object = this.gettersAggInputData
      let obj = {}
      if (object.department) {
        delete object.department
      }
      if (object.subDepartment) {
        delete object.subDepartment
      }
      if (object.class) {
        delete object.class
      }
      if (object.subClass) {
        delete object.subClass
      }
      console.log('In see all categories of sidebar:', object)
      this.department = null
      this.subDepartment = null
      this.textClass = null
      this.subClass = null
      if (object.offers) {
        obj.offers = object.offers.id
      } else {
        if (this.selectedOfferId) {
          obj.offers = this.selectedOfferId.id
          object.offers = this.selectedOfferId
        }
      }
      if (object.period) {
        obj.period = object.period.id
      } else {
        if (this.selectedPeriod) {
          obj.period = this.selectedPeriod.id
          object.period = this.selectedPeriod
        }
      }
      if (object.brand) {
        obj.brandId = object.brand.id
      } else {
        if (this.brand) {
          obj.brandId = this.brand.id
          object.brand = this.brand
        }
      }
      if (object.storeLevel) {
        obj.storeLevel = object.storeLevel.id
      } else {
        if (this.selectedStoreLevel) {
          obj.storeLevel = this.selectedStoreLevel.id
          object.storeLevel = this.selectedStoreLevel
        }
      }
      this.setAggInputData(object)
      console.log('=========')
      this.fetchAggregatedOffer(obj)
    }
  },
  components: {
    SearchableDropdown,
    Dropdown
  },
  watch: {
    selectedMerchant () {
      this.checkMerchantObject()
    },
    selectedVendor () {
      this.checkVendorObject()
    },
    // since refresh set buttonEnabled to false
    emails () {
      if (!this.buttonEnabled) {
        this.checkVendorObject()
      }
    },
    merchants () {
      if (!this.buttonEnabled) {
        this.checkMerchantObject()
      }
    },
    offerNames () {
      this.filteredOfferNames = this.offerNames.id
    },
    filterText () {
      if (this.filterText === '') {
        this.filteredOfferNames = this.offerNames.id
      } else {
        this.filteredOfferNames = this.filterObjects(this.filterText)
      }
    },
    selectedOfferName () {
      if (this.selectedOfferName !== CLEAR_FILTER) {
        if (this.selectedOfferName && this.selectedOfferName.hasOwnProperty('id') &&
        (this.selectedOfferName.id !== this.cloneOfferName.id)) {
          this.setSelectedOffer(this.selectedOfferName)
          this.handleEvent(this.selectedOfferName)
        }
      }
    }
  }
}
</script>

<style scoped>
  .ddOffers {
    padding: 0.5rem 0 0.5rem 0;
    text-decoration: none;
    font-size: 1.2rem;
    color: black;
    width: 90%;
    margin: 1rem;
    height: 3rem;
  }
  .margin_bottom {
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }

  .sideBarStyle {
    height: 100%;
    position: fixed;
    z-index: 15;
    top: 0;
    width: 0;
    padding: 0;
    background-color: white;
    box-shadow: 0 0 5px black;
    overflow-x: hidden;
    transition: 0.5s;
  }

  .openSideBar {
    width: 26rem;
    padding: 1rem 1rem;
  }

  .dataForOffer {
    padding: 0.5rem 0 0.5rem 0;
    text-decoration: none;
    font-size: 1.2rem;
    color: black;
    display: block;
    transition: 0.3s;
    text-align: center;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .ddHeaders {
    padding: 0.5rem 0 0.5rem 0;
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: bold;
    color: black;
    display: block;
  }
  .ddPeriods {
    padding: 0.5rem 0 0.5rem 0;
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: bold;
    color: black;
    display: block;
    margin-top: 18%;
  }
  .ddCategory {
    padding: 0.5rem 0 0.5rem 0;
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: bold;
    color: black;
    display: block;
    margin-top: 18%;
  }

  .all-categories {
    padding: 0.5rem 0 0.5rem 0.8rem;
    text-decoration: underline;
    font-size: 1.1rem;
    color: black;
    display: block;
    cursor: pointer;
  }

  .ddSubHeaders {
    padding: 0.5rem 0 0.5rem 0;
    text-decoration: none;
    font-size: 1rem;
    color: black;
    display: block;
    transition: 0.3s;
  }

  .headerForOffer {
    padding: 0.5rem 0 0.5rem 0;
    text-decoration: none;
    font-size: 1.5rem;
    color: #009933;
    display: block;
    font-weight: bold;
    transition: 0.3s;
    text-align: center;
  }

  .submitButton {
    margin-top: 2rem;
    font-size: 1.2rem;
    font-weight: bold;
  }

  .sideBarStyle .dataForOffer:hover, .offcanvas .dataForOffer:focus{
    background-color: #009933;
    color: white;
  }

  .sideBarStyle .closebtn {
    position: absolute;
    top: 0;
    right: 1rem;
    font-size: 2.5rem;
    margin-left: 5rem;
    cursor: pointer;
  }

  select {
    border-radius: .2rem;
    background: #eee;
    font-size: 1.5rem;
    padding: .5rem 1rem;
    margin: 0.5rem 0.5rem 0.5rem 0;
    height: 3.8rem;
  }

  .searchable {
    margin: 0.5rem 0.5rem 0.5rem 0;
  }

  input {
    font-size: 1.5rem;
    letter-spacing: 0.1rem;
    border-radius:.3rem;
    padding: 1rem;
    background-color: white;
    text-align: center;
  }

  .category-body {
    margin-left: 0.8rem;
  }

  /*.fade-enter-active, .fade-leave-active {
    transition: opacity 2s
  }*/
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
  }

  .grid-12.padding-reset {
    padding: 0;
  }
  .grid-12.margin-reset {
    margin: 0;
  }

  @media screen and (max-height: 450px) {
    .sideBarStyle {padding-top: 15px;}
    .sideBarStyle a {font-size: 18px;}
  }

  .hide {
    display: none;
  }

  .padding-reset.[class*='grid-']:first-of-type {
    padding-left: 0;
  }
  .padding-reset.[class*='grid-']:last-of-type {
    padding-left: 0;
  }
</style>



// WEBPACK FOOTER //
// SideBar.vue?eed1a8a0